<template>
  <a-drawer
    title="公告信息"
    v-model:open="navBarState.showNoticeInfoList"
    class="small notice-info-list-drawer"
    width="90%"
  >
    <a-form
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
      layout="inline"
      style="padding: 0 20px;"
    >
      <a-row :gutter="[0, 10]" class="w-full">
        <a-col :span="8">
          <a-form-item label="关键字">
            <a-input
              v-model:value="noticeInfoState.searchForm.keyword"
              placeholder="请输入关键字查询标题、关键词等内容"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="是否已读">
            <a-radio-group v-model:value="noticeInfoState.searchForm.isRead">
              <a-radio value="">不限</a-radio>
              <a-radio value="0">未读</a-radio>
              <a-radio value="1">已读</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="发布时间">
            <a-range-picker
              v-model:value="noticeInfoState.searchForm.announceTimeList"
              :placeholder="['开始日期', '结束日期']"
              valueFormat="YYYY-MM-DD"
              format="YYYY-MM-DD"
              class="w-full"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="商品大类">
            <cps-select
              v-model:value="noticeInfoState.searchForm.goodsMajorCategoryList"
              placeholder="请选择商品大类"
              url="/dict/list-dict"
              label="dictDesc"
              labelValue="dictCode"
              immediate
              :params="{
                dictType: 8418
              }"
              show-search
              valueType="number"
              mode="multiple"
              :max-tag-count="2"
            ></cps-select>
          </a-form-item>
        </a-col>
        <a-col :span="16" class="text-right">
          <a-button class="mr-8px" @click="reset">重置</a-button>
          <a-button type="primary" @click="refresh">查询</a-button>
        </a-col>
      </a-row>
    </a-form>
    <hr class="mt-10px" />
    <div class="relative !mt-10px mx-20px">
      <div class="absolute top-0 left-0 w-180px">
        <div
          @click="changeTab(item)"
          :class="[
            'w-full px-10px py-12px cursor-pointer',
            {
              'bg-color-[#E6F7FF]': item.key === noticeInfoState.activeKey,
              'text-color-[#1890FF]': item.key === noticeInfoState.activeKey
            }
          ]"
          v-for="item in noticeInfoState.tabList"
          :key="item.key"
        >
          <FileTextOutlined />
          <span class="ml-6px">{{ item.title }}</span>
          <span
            :class="[
              'inline-block align-middle px-8px py-3px text-12px text-center',
              'text-[#848484]',
              'bg-color-[#f0f0f0]',
              'rounded-10px',
              'float-right',
              {
                'text-[#fff]': item.key === noticeInfoState.activeKey,
                'bg-color-[#1890FF]': item.key === noticeInfoState.activeKey
              }
            ]"
            >{{ item.count }}</span
          >
        </div>
      </div>

      <div class="ml-190px inline-block table-contener overflow-hidden ">
        <!-- <a-tabs size="small" v-model:activeKey="noticeInfoState.activeKey">
          <a-tab-pane v-for="item in noticeInfoState.tabList" :key="item.key">
            <template #tab>
              <div>
                <FileTextOutlined class="inline-block align-middle" />
                <span class="inline-block align-middle">{{ item.title }}</span>
                <a-badge
                  class="inline-block align-middle"
                  :count="item.count"
                  :overflow-count="9999999999"
                />
              </div>
            </template> -->
        <remote-table
          ref="tableRef"
          showSetting
          interfaceURL="/announcement-center/read-record"
          :y="noticeInfoState.scrollY"
          :sy="noticeInfoState.scrollY"
          hasAction
          @exportExcel="exportEvent"
          :apiParams="{
            scopeType: 1,
            type: noticeInfoState.activeKey,
            responsibleId: noticeInfoState.userId
          }"
          :showSelection="false"
          :columns="noticeInfoState.noticeInfoColumns"
          :isWatchApiParams="false"
        >
          <template #goodsMajorCategoryStr="{record}">
            <a-tooltip>
              <template #title>{{ record.goodsMajorCategoryStr }}</template>
              <div
                style="overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;"
              >
                {{ record.goodsMajorCategoryStr }}
              </div>
            </a-tooltip>
          </template>
          <template #keyword="{record}">
            <a-tooltip>
              <template #title>{{ record.keyword }}</template>
              <div
                style="overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;"
              >
                {{ record.keyword }}
              </div>
            </a-tooltip>
          </template>
          <template #effectiveTimeStr="{record}">
            {{ record.effectiveTimeStr
            }}<a-button
              danger
              v-if="record.expireFlag"
              size="small"
              class="ml-8px bg-color-[#FFF1F0]"
              >已过期</a-button
            >
          </template>

          <template #isReadStr="{record}">
            <a-button
              class="bg-color-[#F6FFED] text-color-[#B7EB8F] border-solid border-color-[#B7EB8F]"
              size="small"
              v-if="record.isReadStr === '已读'"
              >{{ record.isReadStr }}</a-button
            >
            <a-button
              class="bg-color-[#FFF1F0]"
              size="small"
              danger
              v-if="record.isReadStr === '未读'"
              >{{ record.isReadStr }}</a-button
            >
          </template>
          <template #action="{record}">
            <a-button
              size="small"
              type="link"
              @click="
                ;(noticeInfoState.id = record.id),
                  (noticeInfoState.showDetail = true)
              "
            >
              详情
            </a-button>
          </template>
        </remote-table>
        <!-- </a-tab-pane>
        </a-tabs> -->
      </div>
    </div>
  </a-drawer>
  <noticeDetail
    v-if="noticeInfoState.showDetail"
    :showDetail="noticeInfoState.showDetail"
    :id="noticeInfoState.id"
    @close="noticeInfoState.showDetail = false"
    :toRead="refresh"
  />
</template>
<script setup>
import { inject, defineProps, provide } from 'vue'
import { useNoticeInfoList } from '../share'
import { FileTextOutlined, QuestionCircleOutlined } from '@ant-design/icons-vue'
import noticeDetail from './noticeDetail.vue'
const props = defineProps({
  id: {
    type: [String, Number],
    default: null
  }
})
const navBarState = inject('navBarState')
const {
  noticeInfoState,
  tableRef,
  refresh,
  reset,
  changeTab
} = useNoticeInfoList(props)
provide('noticeInfoState', noticeInfoState)
</script>
<style lang="scss" scoped>
:deep(.portal-ant-list-item-meta-description) {
  font-size: 12px;
}
:deep(.portal-ant-list-item) {
  padding: 6px;
}
:deep(.portal-ant-badge-not-a-wrapper .portal-ant-scroll-number) {
  transform-origin: -50% 240% !important;
}
:deep(.portal-ant-row) {
  // display: none;
}
:deep(.remote-table .portal-ant-row) {
  display: none;
}
.table-contener {
  width: calc(100% - 190px);
}
:deep(.portal-ant-form-item) {
  margin-inline-end: 0;
}
:global(.notice-info-list-drawer .portal-ant-drawer-body) {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
